const n=new WeakMap;function r(e,i){let t=i;for(;t;){if(n.get(t)===e)return!0;t=Object.getPrototypeOf(t)}return!1}function d(e){return i=>{if(r(e,i))return i;const t=e(i);return n.set(t,e),t}}export{d as dedupeMixin};
